import React, { useCallback, useState } from 'react';
import { Card, Tabs } from 'antd';
import { CalendarOutlined, BarsOutlined } from '@ant-design/icons';
import TaskIssueDrawer from '../TaskIssueDrawer';
import MyScheduleCalendar from './MyScheduleCalendar';
import MyScheduleTimeline from './MyScheduleTimeline';
import './MySchedule.scss';

// "My Schedule" card for the Project Board overview: the logged-in employee's
// assigned tasks by planned dates and due date, as a calendar or a timeline.
const MySchedule = ({ filters }) => {
  const [tab, setTab] = useState('calendar');
  const [openTaskId, setOpenTaskId] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [undated, setUndated] = useState(0);
  // Whose schedule this is: me, or the team member picked in the Assignee filter.
  const [owner, setOwner] = useState({ isMe: true, name: '' });

  const openTask = useCallback((id) => setOpenTaskId(id), []);
  const onUndatedCount = useCallback((n, data) => {
    setUndated(n);
    if (data) setOwner({ isMe: data.is_me !== false, name: data.user_name || '' });
  }, []);
  const shared = { reloadKey, filters, onOpenTask: openTask, onUndatedCount };

  return (
    <Card
      title={owner.isMe ? 'My Schedule' : `Schedule: ${owner.name}`}
      extra={!owner.isMe && <span style={{ fontSize: 12, color: '#59636e' }}>Clear the Assignee filter to see yours</span>}
      className="ms-card"
      style={{ marginBottom: 24 }}
    >
      <div className="ms-legend">
        <span><i className="ms-legend__bar" /> Planned start → end</span>
        <span><i className="ms-legend__due">🚩</i> Due date</span>
        <span><i className="ms-legend__overdue" /> Overdue</span>
        <span><i className="ms-legend__done" /> Completed</span>
      </div>

      <Tabs
        activeKey={tab}
        onChange={setTab}
        destroyInactiveTabPane
        items={[
          { key: 'calendar', label: <span><CalendarOutlined /> Calendar</span>, children: <MyScheduleCalendar {...shared} /> },
          { key: 'timeline', label: <span><BarsOutlined /> Timeline</span>, children: <MyScheduleTimeline {...shared} /> },
        ]}
      />

      {undated > 0 && (
        <div className="ms-note">
          {undated} {owner.isMe ? '' : `of ${owner.name}'s `}assigned task{undated === 1 ? ' has' : 's have'} no planned or due dates, so {undated === 1 ? 'it is' : 'they are'} not shown here.
        </div>
      )}

      <TaskIssueDrawer
        visible={!!openTaskId}
        taskId={openTaskId}
        onClose={() => { setOpenTaskId(null); setReloadKey((k) => k + 1); }}
        onSuccess={() => setReloadKey((k) => k + 1)}
      />
    </Card>
  );
};

export default MySchedule;
